export var PLACEHOLDER_IMAGE_URL = "https://cdn.faire.com/fastly/381a528f8a48688ec95063357de2dafa7fe7f6f3d59474e380dee0d9a826b48a.png";
